/**
 * Ticket module constants — ported verbatim from
 * `datacentral-client-v4/src/modules/Ticket/constants.ts`.
 * Consumed by all ticket UI agents (B / C / D).
 */

/* ── Type-group keys ──────────────────────────────────────────────────────── */

export const TICKET_TYPE_GROUP_MEETING = 'meeting'
export const TICKET_TYPE_GROUP_SUPPORT_REQUEST = 'support_request'

/* ── Service ticket type keys ────────────────────────────────────────────── */

export const SERVICE_CREATING_KEY = 'service_creating'
export const SERVICE_CANCELLED_KEY = 'service_cancelled'
export const SERVICE_SUSPEND_KEY = 'service_suspend'
export const SERVICE_CREATING_POC_KEY = 'service_creating_poc'

export const ERROR_SERVICE_INCIDENT_TICKET_KEY = 'error_service_incident'
export const MEETING_TICKET_KEY = 'meeting'

/* ── Status keys ─────────────────────────────────────────────────────────── */

export const TICKET_STATUS_OPENING = 'opening'
export const TICKET_STATUS_WORK_IN_PROGRESS = 'work-in-progress'
export const TICKET_STATUS_COMPLETED = 'completed'
export const TICKET_STATUS_CLOSED = 'closed'
export const TICKET_STATUS_ESCALATED = 'escalated'

/* ── Status → display label map ──────────────────────────────────────────── */

/** Maps each backend status value to the UI label shown on badges/filters. */
export const TICKET_STATUS_LABEL: Record<string, string> = {
  [TICKET_STATUS_OPENING]: 'NEW',
  [TICKET_STATUS_WORK_IN_PROGRESS]: 'IN PROGRESS',
  [TICKET_STATUS_COMPLETED]: 'RESOLVED',
  [TICKET_STATUS_CLOSED]: 'CLOSED',
  [TICKET_STATUS_ESCALATED]: 'ESCALATED',
}

/* ── Security classification tag values (IT-ISMS QT-01 §4.2) ────────────── */

export const SECURITY_TAG_NONE = 'none'
export const SECURITY_TAG_SECURITY = 'security'
export const SECURITY_TAG_SERVICE = 'service'
export const SECURITY_TAG_BOTH = 'both'
